<div id="loading-content" style="text-align: center;">
  <div id="vertical-separator"></div>
  <div>
    <span class="text-primary font-weight-bold">{{ "MESSAGE.LOADING" | translate }}</span>
  </div>
  <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
  </div>
</div>
